// 生产环境通过 .env 设置: REACT_APP_API_BASE=https://api.yourdomain.com
export const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
